import { gql } from '@apollo/client';

import { professorActivityAnswerFragment } from '../fragments';
import { ProfessorActivityAnswer } from '../../types';

export interface GetActivityAnswerQueryVariables {
  courseId: string;
  activityId: string;
  answerId: string;
}

export interface GetActivityAnswerQueryResult {
  answer: ProfessorActivityAnswer;
}

export const getActivityAnswerQuery = gql`
  query GetActivityAnswerQuery($courseId: String!, $activityId: String!, $answerId: String!) {
    answer(courseId: $courseId, activityId: $activityId, answerId: $answerId)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}") {
      ...ProfessorActivityAnswer
    }
  }
  ${professorActivityAnswerFragment}
`;
